module.exports = new __parcel__URL__("BrickFlicks.e91d9646.avif").toString();